import { ServicePaymentMedicalProcedureGridItemObject, ServicePaymentMedicalProcedureGridObject } from '@it2go/types';
import { EventEmitter, Injectable, inject } from '@angular/core';
import { ComponentStoreFactory } from '../../../../../shared/store/common/component-store.factory';
import { Store } from '@ngrx/store';
import { ServiceService } from '../../../../../../services/service.service';
import { EMPTY, Observable } from 'rxjs';
import { GridInput } from '@it2go/data-grid';
import { catchError, switchMap, tap } from 'rxjs/operators';
import {
    ServiceMedicalProcedureGridObject,
    ServiceMedicalProcedureObject,
} from '@libs/types/src/services/object-type/service/service-medical-procedure.object';

interface State {
    serviceMedicalProcedures: ServiceMedicalProcedureGridObject | null,
    servicePaymentMedicalProcedures: ServicePaymentMedicalProcedureGridObject | null;
}

const defaultState: State = {
    serviceMedicalProcedures: null,
    servicePaymentMedicalProcedures: null,
};

@Injectable()
export class ServicePaymentMedicalProceduresStore extends ComponentStoreFactory<State> {

    private readonly svc = inject(ServiceService);

    medicalProcedures$ = this.data.serviceMedicalProcedures$.gridItems<ServiceMedicalProcedureObject>(true);
    servicePaymentMedicalProcedures$ = this.data.servicePaymentMedicalProcedures$.gridItems<ServicePaymentMedicalProcedureGridItemObject>();

    checkDuplicateResponse = new EventEmitter<ServicePaymentMedicalProcedureGridItemObject[]>();
    checkDuplicate = this.effect((input$: Observable<GridInput>) => input$.pipe(
            switchMap((input) => this.svc.getServicePaymentMedicalProcedures(input).pipe(
                tap({
                    next: (result) => {
                        this.checkDuplicateResponse.emit(result?.['items'] || []);
                    },
                }),
                catchError(() => EMPTY),
            )),
        ),
    );

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
    }
}
